function Stats(){
    return (

        <section className="bg-light py-5">
            <div className="container text-center gray-500">
            <div className="row py-6">
                {/* row */}
                <div className="col-md-6 col-lg-12 ">
                    {/* heading */}
                    <h1 className="display-4 fw-bold mb-3">Our Impact in Numbers</h1>
                    {/* para */}
                    <p className="lead">
                    <span className="fw-bold">Asic</span><span className="fw-bold text-danger">Flow</span> is the ultimate gateway to open-source chip design, providing engineers, 
                    researchers, and enthusiasts with seamless access to powerful tools, expert resources, 
                    and a thriving community. Whether you're prototyping, optimizing, or pushing the boundaries 
                    of innovation, we make chip design more accessible, efficient, and collaborative than ever before.
                    </p>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                    {/* counter */}
                    <div className="border-top pt-4 mt-6 mb-5">
                    <h1 className="display-3 fw-bold mb-0">10</h1>
                    <p className="text-uppercase ">Users</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                    {/* counter */}
                    <div className="border-top pt-4 mt-6 mb-5">
                    <h1 className="display-3 fw-bold mb-0">3</h1>
                    <p className="text-uppercase ">Tools</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                    {/* counter */}
                    <div className="border-top pt-4 mt-6 mb-5">
                    <h1 className="display-3 fw-bold mb-0">1</h1>
                    <p className="text-uppercase ">Blog Entries</p>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-6">
                    {/* counter */}
                    <div className="border-top pt-4 mt-6 mb-5">
                    <h1 className="display-3 fw-bold mb-0">1000</h1>
                    <p className="text-uppercase ">Daily Access Count</p>
                    </div>
                </div>
                </div>
            </div>
        </section>
    );
}

export default Stats